var map = {
	"./Brutus/Happy.svg": 297,
	"./Brutus/Masked.svg": 298,
	"./Brutus/Normal.svg": 299,
	"./Brutus/Surprise.svg": 300,
	"./Brutus/Thinking.svg": 301,
	"./Campus-Active-Dark.svg": 517,
	"./Campus-Active.svg": 518,
	"./Campus-Inactive-Dark.svg": 519,
	"./Campus-Inactive.svg": 520,
	"./For-You-Active-Dark.svg": 521,
	"./For-You-Active.svg": 522,
	"./For-You-Inactive-Dark.svg": 523,
	"./For-You-Inactive.svg": 524,
	"./Parking-Active-Dark.svg": 525,
	"./Parking-Active.svg": 526,
	"./Parking-Inactive-Dark.svg": 527,
	"./Parking-Inactive.svg": 528,
	"./block-osu-darkmode.svg": 529,
	"./block-osu.svg": 530,
	"./certified.svg": 531,
	"./compass-darkmode.svg": 291,
	"./compass-normal.svg": 290,
	"./placeholders/building-day.svg": 294,
	"./placeholders/building-night.svg": 295,
	"./placeholders/standard-day.svg": 292,
	"./placeholders/standard-night.svg": 293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 296;